import { render } from "./PlansCheckoutOffcanvas.vue?vue&type=template&id=264df0b4&scoped=true"
import script from "./PlansCheckoutOffcanvas.vue?vue&type=script&lang=js"
export * from "./PlansCheckoutOffcanvas.vue?vue&type=script&lang=js"

import "./PlansCheckoutOffcanvas.vue?vue&type=style&index=0&id=264df0b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264df0b4"]])

export default __exports__